import { useEffect, useState } from "react";
import Modal from "./Modal";
import { Responsive, WidthProvider } from "react-grid-layout";
import { useFormContext } from "react-hook-form";
const ResponsiveGridLayout = WidthProvider(Responsive);

const ReorderImageModal = ({ setReorderImageModal, acceptedImageFiles }) => {
  const { setValue, watch } = useFormContext();
  const [layouts, setLayouts] = useState({
    lg: [],
    md: [],
    sm: [],
    xs: [],
    xxs: [],
  });
  const [rowHeight, setRowHeight] = useState(210);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const onLayoutChange = (layout) => {
    if (JSON.stringify(layout) !== JSON.stringify(layouts)) {
      setLayouts(layout);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const baseLayout = acceptedImageFiles.map((file, index) => ({
      x: 0,
      y: index,
      w: 1,
      h: 1,
      i: index.toString(),
      src: file,
    }));
    setLayouts({
      lg: baseLayout,
      md: baseLayout,
      sm: baseLayout,
      xs: baseLayout,
      xxs: baseLayout,
    });
  }, [acceptedImageFiles]);

  useEffect(() => {
    if (screenWidth < 420) {
      setRowHeight(200);
    } else if (screenWidth < 768) {
      setRowHeight(160);
    } else if (screenWidth < 996) {
      setRowHeight(160);
    } else if (screenWidth < 1200) {
      setRowHeight(160);
    }
  }, [screenWidth]);

  const handleSave = () => {
    const orderedIds = [...layouts]
      .sort((a, b) => a.y - b.y || a.x - b.x)
      .map((item) => {
        return {
          index: item.i,
          url: acceptedImageFiles[item.i],
        };
      });

    const updatedImageUrls = orderedIds.map((id) => {
      return {
        index: id.index,
        url: id.url,
      };
    });

    if (JSON.stringify(updatedImageUrls) !== JSON.stringify(watch("images"))) {
      setValue("images", updatedImageUrls);
    }
    setReorderImageModal(false);
  };

  return (
    <Modal
      handleClick={() => setReorderImageModal(false)}
      title="Reorder Images"
      closeName="Cancel"
      submitName="Save"
      removeButtons
    >
      <p className="text-sm px-5">
        Please drag and drop the below media items to rearrange them and please
        do not forget to hit the 'Save' button on the 'Create page' form to save
        this change.
      </p>
      <section className="p-5 sm:h-[calc(100vh-500px)] h-[calc(100vh-300px)] overflow-y-auto">
        <div style={{ width: "100%", height: "auto" }}>
          <ResponsiveGridLayout
            className="layout"
            layouts={layouts}
            onLayoutChange={onLayoutChange}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 420, xxs: 0 }}
            cols={{ lg: 3, md: 2, sm: 2, xs: 3, xxs: 1 }}
            rowHeight={rowHeight}
            isResizable={false}
            isDraggable={true}
            compactType="horizontal"
          >
            {acceptedImageFiles.map((file, index) => {
              const cols = 3;
              const idx = index;
              const x = idx % cols;
              const y = Math.floor(idx / cols);

              const imageSrc =
                typeof file.url === "string"
                  ? file.url
                  : file instanceof File
                  ? URL.createObjectURL(file)
                  : typeof file.url.url === "string"
                  ? file.url.url
                  : file.url instanceof File
                  ? URL.createObjectURL(file.url)
                  : "";

              const imageName =
                typeof file.url === "string"
                  ? file.url.split("/").pop()
                  : file instanceof File
                  ? file.name
                  : typeof file.url.url === "string"
                  ? file.url.url.split("/").pop()
                  : file.url instanceof File
                  ? file.url.name
                  : "";

              return (
                <div
                  key={index}
                  className="relative"
                  data-grid={{
                    x,
                    y,
                    w: 1,
                    h: 1,
                    i: index.toString(),
                    src: file,
                  }}
                >
                  <img
                    src={imageSrc}
                    alt={imageName}
                    className="object-cover w-full h-full"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-1">
                    <div className="flex justify-between items-center">
                      <p className="text-white text-xs w-[100px] truncate">
                        {imageName}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </ResponsiveGridLayout>
        </div>
      </section>
      <div className="flex items-center gap-3 px-6 py-6">
        <button
          onClick={() => {
            setReorderImageModal(false);
          }}
          type="button"
          className="justify-center w-full bg-red-500 hover:bg-red-600 text-sm sm:text-base text-white px-3 py-2 rounded border border-borderMuted flex focus:outline-none transition-all duration-500"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSave}
          className="focus:outline-none justify-center disabled:bg-gray-400 text-white text-sm sm:text-base bg-[#0082B2] hover:bg-[#006d95] rounded px-3 py-2 w-full transition duration-150 ease-in"
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default ReorderImageModal;
